// ----------------------------------------------------------------------
// <copyright file="Izenda.AdvancedImport.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
* Advanced Import component
*/
!function () {
  "use strict";
  require('share/utils/Izenda.StringUtilities');
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var Mapping = require('./Mapping/Izenda.Mapping');
  var SourceDestinationContainer = require('./Izenda.SourceDestinationContainer');
  var AdvancedImportToolbar = require('./Izenda.AdvancedImportToolbar');

  var AdvancedImport = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    renderHeader: function () {
      const { localization, store : { dataModelImport: { selectedTenant } } } = this.props;

      return (
           <div className='u_marginBottom'>
              <span className='text-bold u_inlineBlock'>{localization.getText('IMPORT_DATAMODEL_LABEL_ADVANCED_OPTIONS')}</span>
              <span> </span>
              <span className='u_inlineBlock text-bold'>{selectedTenant.tenantName}</span>
           </div>
      )
    },

    render: function () {
      const { store, store: { dataModelImport: { alertMessage } }, onClose, onValidate } = this.props;
      return (
        <section className="izenda-Wrapper">
          <AdvancedImportToolbar onClose={onClose} onValidate={onValidate} alertMessage={alertMessage} />
          <div className="izenda-Wrapper-content">
            <ScrollBox>
              <div className="u_paddingLeftRight">
                {this.renderHeader()}
                <Mapping store={store} />
                <SourceDestinationContainer store={store}/>
              </div>
            </ScrollBox>
          </div>
        </section>
      );
    }
  });

  module.exports = connect()(AdvancedImport);
}();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/DataModel/AdvancedImport/Izenda.AdvancedImport.jsx